module Client.Infrastructure.Api

open Fable.Remoting.Client
open Shared

let api =
    Remoting.createApi ()
    |> Remoting.withRouteBuilder Route.builder
    |> Remoting.buildProxy<MySenseApi>